import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'currencyThousand'
})
export class CurrencyThousandPipe implements PipeTransform {

    constructor() {
    }

    transform(value: number, currencySymbol: string, ): string {
        if (value == 0) {
            return currencySymbol + "0k";
        }

        let resultThousands = value / 1000;
        let resultRound = resultThousands.toLocaleString(undefined, { maximumFractionDigits: 2 });

        return currencySymbol + resultRound + "k"
    }
}